@if (actionsInFooter) {
  <ds-modal
    [modal]="modal"
    [title]="title"
    [maxWidthPercentage]="maxWidthPercentage"
    (modalClosed)="onClose()"
    [closeAllModals]="closeAllModals"
  >
    <ng-container [ngTemplateOutlet]="content" />
    <ng-template ds-modal-slide-out-footer>
      <div class="w-100">
        <ng-container [ngTemplateOutlet]="actions" />
      </div>
    </ng-template>
  </ds-modal>
} @else {
  <ds-modal
    [modal]="modal"
    [title]="title"
    [maxWidthPercentage]="maxWidthPercentage"
    (modalClosed)="onClose()"
    [closeAllModals]="closeAllModals"
  >
    <ng-container [ngTemplateOutlet]="content" />
    <ng-container [ngTemplateOutlet]="actions" />
  </ds-modal>
}

<ng-template #content>
  @if (message) {
    <p data-test-id="ds-modal-message" class="message">{{ message }}</p>
  }
  @if (description) {
    @if (descriptionIsHTML) {
      <p data-test-id="ds-modal-description" [innerHTML]="description"></p>
    } @else {
      <p data-test-id="ds-modal-description">{{ description }}</p>
    }
  }
</ng-template>

<ng-template #actions>
  <ds-button-group
    [primaryAction]="{ label: confirmLabel || 'label_confirm' | translate }"
    [secondAction]="{
      label: cancelLabel || 'form_cancel' | translate,
      variant: hideCancelButton ? null : DsButtonVariants.secondary,
    }"
    (primaryActionClicked)="onConfirm()"
    (secondActionClicked)="onCancel()"
  >
  </ds-button-group>
</ng-template>
